import { Intent } from "@blueprintjs/core";
import { LinkButton } from "components/buttons";
import { DateToLocal } from "components/dates";
import { FormSelect } from "components/form-fields";
import { ListingTable } from "components/listing";
import { NotificationToaster } from "components/notifications";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { AlertService } from "services";

export function EmployeeLicenceCheckAlerts({
    employeeId
}) {

    const tableHeaders = ["Severity", "Type", "Description", "Date", ""];
    const [tableRows, setTableRows] = useState([]);
    const alertStatuses = [
        { id: "Active", name: "Active Alerts" },
        { id: "Dismissed", name: "Dismissed Alerts" },
    ];

    const alertSeverities = [
        { id: 42, name: "Critical", key: "licence-check-critical" },
        { id: 41, name: "High", key: "licence-check-high" },
        { id: 40, name: "Medium", key: "licence-check-medium" },
        { id: 39, name: "Low", key: "licence-check-low" },
    ]

    const [loadingData, setLoadingData] = useState(true);

    const [selectedStatus, setSelectedStatus] = useState("Active");

    useEffect(() => {

        if (employeeId == null) {
            return;
        }

        setLoadingData(true);

        const pageSize = 1000;
        const pageNumber = 1;

        const allFilters = [
            {
                key: 'EntityId',
                value: employeeId
            }, {
                key: 'AlertStatus',
                value: selectedStatus
            }
        ];

        const alertRequest = {
            requestCount: pageSize,
            pageNumber: pageNumber,
            searchTerm: '',
            sortField: 'alertTypeId',
            sortDirection: 'D',
            alertTypeIds: alertSeverities.map((s) => s.id),
            filters: allFilters
        };

        AlertService.getAlerts(alertRequest).then(r => {
            let data = [];
            if (r?.data != null) {
                data = r.data.map((d) => {

                    var severity = alertSeverities.find((s) => s.id === d.alertTypeId);

                    return [
                        severity.name ?? "Unknown",
                        d.alertData.title,
                        d.alertData.message,
                        <DateToLocal key={d.alertId} format="DD/MM/YYYY">{d.eventTime}</DateToLocal>,
                        <LinkButton key={d.alertId} text="View Alert" large={false} intent="primary" href={`/alert/${severity.key}?searchTerm=${encodeURIComponent(d.entity.employee.fullName)}`} />,
                    ];
                });
            }

            setTableRows(data);

        }, () => {
            NotificationToaster.show(Intent.DANGER, "Could not load alerts. Please try again.")
        }).finally(() => {
            setLoadingData(false);
        });

    }, [employeeId, selectedStatus]);

    return (
        <div>
            <FormSelect
                items={alertStatuses}
                placeholder="Select an Alert Status"
                selectedValue={selectedStatus}
                onItemSelect={(item) => setSelectedStatus(item.id)}
                disabled={loadingData}
            />
            <ListingTable
                id="listing-table-licence-alerts"
                noDataMessage={"No alerts have been raised for this employee"}
                sortable={false}
                headers={tableHeaders}
                data={tableRows}
                totalRecordCount={tableRows.length}
                pageable={false}
                showPerPage={false}
                loadingData={loadingData}
                shrinkLastColumn={true}
            />
        </div>
    );
}

EmployeeLicenceCheckAlerts.propTypes = {
    employeeId: PropTypes.string.isRequired
};